import { useMutation } from 'react-query';
import { network } from 'services/network';

const mutationFn = (params: QueryParams) => {
    const formData = new FormData();
    if (params.file !== null) {
        if (typeof params.file.size !== 'undefined') {
            formData.append('file', params.file, params.file.name);
        }
    }

    params.tags && formData.append('tags', JSON.stringify(params.tags));
    params.assignee && formData.append('assignee', JSON.stringify(params.assignee));
    params.contractId && formData.append('contractId', JSON.stringify(params.contractId));

    return network
        .post<QueryResponse>('api/bo/importExternalRisks', formData, {
            transformRequest: [
                (data, headers) => {
                    if (headers) {
                        headers['Content-Type'] = 'multipart/form-data';
                    }
                    return data;
                },
            ],
        })
        .then((response) => {
            return response.data;
        });
};

export const useMutationUploadRiskRegisterCsv = () => {
    return useMutation<QueryResponse, QueryError, QueryParams, unknown>((params) => mutationFn(params));
};

interface QueryParams {
    assignee: string | null;
    tags: string[];
    file: File;
    contractId: number | undefined;
}

interface QueryResponse {
    status: string;
    warnings: string[];
}
